const locale = {
	pageTitle: '聯絡我們 | 擎億精密有限公司',
	pageDesc: '聯絡擎億精密，取得走心機 CNC 精密加工報價。Cincom L20 瑞士型走心機，φ1–20mm 小徑零件，公差 ±0.005mm，ISO 9001 認證。電話：0966-686-161。',
	pageKeywords: '擎億精密聯絡, 走心機詢價, Cincom L20 報價, 精密加工詢問, 瑞士型車床加工, CNC 加工聯絡, 新北市精密加工',
	title: '聯絡我們',
	subtitle: '請填寫以下表單，我們將盡速與您聯繫',
	name: '公司名稱 / 姓名',
	namePlaceholder: '擎億精密',
	phone: '聯絡電話',
	phonePlaceholder: '02-8687-2058',
	email: '電子信箱',
	emailPlaceholder: 'example@company.com',
	content: '詢問內容',
	contentPlaceholder: '請描述您的需求，例如：材質、數量、加工規格等…',
	file: '附件',
	selectFile: '選擇檔案',
	send: '送出詢問',
	errorName: '請輸入公司名稱或姓名',
	errorContact: '請輸入電話或電子信箱至少一項',
	errorEmail: '電子信箱格式不正確',
	mapTitle: '公司位置'
};

export default locale;
